"use strict";

/**
 * This is the list of currencies used in application with some hints
 * for proper rendering.
 *
 * `code` is a currency code according to ISO 4217
 */
var prepend = true;
module.exports = [{
  code: 'GBP',
  prepend: prepend,
  ratio: 100,
  symbol: '£'
}, {
  code: 'EUR',
  prepend: prepend,
  ratio: 100,
  symbol: '€'
}, {
  code: 'NOK',
  ratio: 100,
  symbol: 'kr'
}, {
  code: 'SEK',
  ratio: 100,
  symbol: 'kr'
}, {
  code: 'USD',
  prepend: prepend,
  ratio: 100,
  symbol: '$'
}, {
  code: 'CAD',
  prepend: prepend,
  ratio: 100,
  symbol: 'CA$'
}, {
  code: 'BALLS',
  prepend: prepend,
  ratio: 100,
  symbol: ''
}, {
  code: 'BRAINS',
  prepend: prepend,
  ratio: 100,
  symbol: ''
}, {
  code: 'RUBIES',
  prepend: prepend,
  ratio: 1,
  symbol: ''
}];